import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/index.css';
import './css/fa-all.min.css';
import './i18n';
import { Suspense } from 'react';
import { AuthenticationProvider } from 'common/contexts/Authentication';
import { FlashMessagesProvider } from 'common/contexts/FlashMessages';
import { ReportsProvider } from 'common/contexts/Reports';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import { baseUrl } from 'Constants';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback='Loading…'>
    <React.StrictMode>
      <AuthenticationProvider>
        <FlashMessagesProvider>
          <ReportsProvider>
              <Router basename={baseUrl}>
                <Route path=''>
                  <App />
                </Route>
              </Router>
          </ReportsProvider>
        </FlashMessagesProvider>

      </AuthenticationProvider>
    </React.StrictMode>
  </Suspense>,
  </React.StrictMode>,
  document.getElementsByTagName('body')[0]
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
